import { useTranslations } from '@vocab/react';
import { IconRenderer } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';
import { IconVerifiedTransparentSVG } from './IconVerifiedTransparentSVG';

export const IconVerifiedTransparent: FC = () => {
  const { t } = useTranslations(translations);
  return (
    <IconRenderer>
      {({ className }) => (
        <IconVerifiedTransparentSVG
          className={className}
          title={t('Verified Icon')}
        />
      )}
    </IconRenderer>
  );
};
